/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import PropTypes from 'prop-types';

const limit = 10;
const propTypes = {
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  hideLabel: PropTypes.bool,
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  hideLabel: false,
  customFilter: {},
  value: '',
};

const CustomerClusterSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    hasError = false,
    hideLabel = false,
    customFilter = {},
    value = '',
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const getCustomerClusterRule = useApi(MsAccount.getCustomerClusterRule);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {
        is_active: true,
      };
      if (customFilter && Object.keys(customFilter).length) {
        filter = {
          ...filter,
          ...customFilter,
        };
      }
      if (val) {
        filter.name = { $regex: val, $options: 'i' };
      }
      if (!val && filter.name) {
        delete filter.name;
      }
      const response = await getCustomerClusterRule.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      {...props}
      label={'Discount Regular'}
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore ? 'Loading...' : 'Select Discount'
      }
      trackBy="id"
      labelKey="name"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial}
      hasError={hasError}
      hideLabel={hideLabel}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        setSkip(0);
        onSearch();
      }}
    />
  );
};

CustomerClusterSearch.propTypes = propTypes;
CustomerClusterSearch.defaultProps = defaultProps;

export default CustomerClusterSearch;
